const setupAutoconverse = function() {
    const forms = document.querySelectorAll('.autoconverse__form');
    const formsLength = forms.length;
    if (formsLength == 0) {
        return;
    }
    for (let index = 0; index < formsLength; index++) {
        const form = forms[index];
        form.addEventListener('submit', function(event) {
            event.preventDefault();
            autoSearch.showSearch(event, '784b3fba-bcd6-42cd-b185-29302fb90a72', form.querySelector('.autoconverse__input').value);
            return false;
        });
    }
}

export default function() {
    setupAutoconverse();
}